import React from 'react';
import { Box, Text, Newline } from 'ink';
import { useTheme } from './lib/theme';

interface ErrorMessageProps {
  error: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error }) => {
  const { tokens } = useTheme();
  return (
    <Box flexDirection="column" marginY={0}>
      <Box>
        <Text color={tokens.text.danger}>❌ Error:</Text>
      </Box>
      <Box paddingLeft={2}>
        <Text color={tokens.text.danger}>{error}</Text>
      </Box>
      <Newline />
    </Box>
  );
};
